import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'mini-chart',
    template: '',
    styleUrls: []
})
export class MiniChartsBase {
    protected get defaultWidth() { return 12.5; }
    protected get defaultHeight() { return 12.5; }
    protected get defaultSize() { return 24; }
    widthInRem = input<number>(this.defaultWidth, { alias: 'width' });
    width = computed(() => this.remToPx(this.widthInRem()));
    heightInRem = input<number>(this.defaultHeight, { alias: 'height' });
    height = computed(() => this.remToPx(this.heightInRem()))
    size = input<number>(this.defaultSize);
    valueProvided = input.required<number | string>({ alias: 'value' });
    value = computed(() => this.toFixed(this.valueProvided()))
    displayValueProvided = input<number | string | undefined>(undefined, { alias: 'displayValue' });
    hasDisplayOverride = computed(() => {
        const override = this.displayValueProvided();
        return override !== undefined && override !== null;
    });
    displayValue = computed(() => this.hasDisplayOverride() ? this.displayValueProvided() : this.value());
    color = input<string>('#0082C6');
    background = input<string>('#E6EBF8')

    remToPx(x: number): number {
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return 16

        const fs = getComputedStyle(document.documentElement).fontSize;
        const px = Number(fs.replace('px', ''));
        const rem = Number.isFinite(px) && px > 0 ? px : 16;
        return x * rem
    }

    toFixed(number, digits = 1) {
        const value = parseFloat(number).toFixed(digits);
        return value == 'NaN' ? 0 : value;
    }
}